import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'

export const jumpStateList = ['confirm', 'stateReturn'] as const
export type jumpStateKey = keyof typeof jumpStateList
interface State {
  checkedOrderKey: OrderType
}
export const ORDER_TYPE_LIST = ['LAUNCHGOODS', 'LAUNCHBRAND'] as const
export type OrderType = (typeof ORDER_TYPE_LIST)[number]
const isOrderType = (val: string): val is OrderType =>
  (ORDER_TYPE_LIST as readonly string[]).includes(val)
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'LAUNCHGOODS',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  const query = useQuery()
  const type = query.get('type') || ''

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    }
    // eslint-disable-next-line
  }, [])

  // url 上的 type 优先于页面缓存，需在缓存恢复之后执行
  useEffect(() => {
    isOrderType(type) && changeOrder(type)
    // eslint-disable-next-line
  }, [type])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
  }
}
import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { useQuery } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'

export const jumpStateList = ['confirm', 'stateReturn'] as const
export type jumpStateKey = keyof typeof jumpStateList
interface State {
  checkedOrderKey: OrderType
}
export const ORDER_TYPE_LIST = ['LAUNCHGOODS', 'LAUNCHBRAND'] as const
export type OrderType = (typeof ORDER_TYPE_LIST)[number]
const isOrderType = (val: string): val is OrderType =>
  (ORDER_TYPE_LIST as readonly string[]).includes(val)
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'LAUNCHGOODS',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  const query = useQuery()
  const type = query.get('type') || ''

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    }
    // eslint-disable-next-line
  }, [])

  // url 上的 type 优先于页面缓存，需在缓存恢复之后执行
  useEffect(() => {
    isOrderType(type) && changeOrder(type)
    // eslint-disable-next-line
  }, [type])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
  }
}
